import { render, staticRenderFns } from "./inputselect.vue?vue&type=template&id=4993e3f0&"
import script from "./inputselect.vue?vue&type=script&lang=js&"
export * from "./inputselect.vue?vue&type=script&lang=js&"
import style0 from "./inputselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports